import {Component, OnInit} from '@angular/core';
import {SystemUserService} from '../../../services/system-user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  standalone: false,
    selector: 'app-system-user-edit',
    templateUrl: './system-user-detail.component.html',
})
export class SystemUserDetailComponent implements OnInit {
    systemUserId = '';
    systemUser: any = {
          first_name: '',
          last_name: '',
          email: '',
          mobile_number: '',
          id_role: 1,
          status: 1
      };
  
      validationTriggered = false;
  
      constructor(
          private systemUserService: SystemUserService,
          private activatedRoute : ActivatedRoute,
          private spinner : NgxSpinnerService,
          private router: Router,
      ) {}
  
      ngOnInit(): any {
        this.activatedRoute.paramMap.subscribe((params: any) => {
          this.systemUserId = params.params.id;
          this.getSystemUserDetail();
      });
        
      }
  
      getSystemUserDetail(): void {
          this.spinner.show();
          this.systemUserService.getSystemUser(this.systemUserId).subscribe((result : any) => {
              this.spinner.hide();   
              this.systemUser = {
                  first_name: result.first_name,
                  last_name: result.last_name,
                  email: result.email,
                  mobile_number: result.mobile_number,
                  id_role: result.id_role,
                  status: result.status,
                  id_branch: result.id_branch
              }
          },
          (error : any) => {
              this.spinner.hide();
              console.log(error);
          });
      }
  
      isSystemUserFilled(systemUser: any): boolean {
          for (const su in systemUser) {
              if (su != 'id_role') {
                  if (systemUser[su] == '') {
                      return false;
                  }
              } 
          }
          return true;
      }
  
      isValidEmail(email: string): boolean {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailPattern.test(email);
      }
  }